import { render, staticRenderFns } from "./matchHDPOUMMOOdds.vue?vue&type=template&id=5ffc6a12&lang=pug&"
import script from "./matchHDPOUMMOOdds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOUMMOOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports